import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAToast } from '@Atoms';
import { API_URL } from '@Constants';
import { resetAllStores } from '@Libraries';
import { useSessionStore } from '@Stores';
import { useForm } from '@FormModule';
import { useFieldsLogin } from '../composables';
import { CsrfService, FetchProfileService, LoginService } from '../services';

export default function () {
  const { isSU, shelterProfile } = storeToRefs(useSessionStore());
  const { initProfile } = useSessionStore();

  const { currentSchemaModels, fieldsSchema, formError } = useFieldsLogin();
  const { fieldsValidation } = useForm();
  const { push } = useRouter();
  const { reset: resetToast } = useAToast();

  const loading = ref(false);
  const isCredentialsError = ref();

  async function onLoginSubmit() {
    const hasErrors = fieldsValidation(fieldsSchema.value, currentSchemaModels.value);
    if (hasErrors) return;

    loading.value = true;
    formError.value = false;

    await CsrfService()
      .then(async () => await onValidCsrf())
      .catch((error) => {
        console.error('CsrfService Error', error);

        formError.value = 'auth.login.errors.refresh';
        loading.value = false;
      });
  }

  async function onValidCsrf() {
    const [email, password] = currentSchemaModels.value;
    const payload = { email: email.value, password: password.value };

    await LoginService(payload)
      .then(async () => await onValidLogin())
      .catch((error: any) => {
        isCredentialsError.value =
          error.response.data.errors.email[0] || error.response.data.errors.password[0];

        // TODO :: AF-180 - Sanitize API errors
        formError.value = isCredentialsError.value || error.response.data.message;

        loading.value = false;
      });
  }

  async function onValidLogin() {
    await FetchProfileService()
      .then((profileData) => {
        resetAllStores();

        initProfile(profileData);

        resetToast();

        if (profileData?.shelter?.new_platform || isSU.value) {
          // prettier-ignore
          const redirectTo = isSU.value
            ? '/admin/shelters'
            : `/shelter${shelterProfile.value.home_page || '/animals/in-care'}`;

          push(redirectTo);
          return;
        }

        return (window.location.href = `${API_URL}${shelterProfile.value.home_page || '/animals/in-care'}`);
      })
      .catch((error) => {
        console.error('FetchProfileService Error', { ...error });
        formError.value = 'auth.login.errors.refresh';
      })
      .finally(() => (loading.value = false));
  }

  return {
    loading,
    isCredentialsError,
    onLoginSubmit,
  };
}
